import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c3cd17f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "location-form" }
const _hoisted_2 = { action: "" }
const _hoisted_3 = { class: "error-message" }

import FormButtons from '../FormButtons.vue';
  import InputField from '@/components/InputField.vue';
  import { ref } from 'vue';
  import { LocationData, FormItem } from '@/models/FormModels';
  import * as locationFormData from '@/assets/data/locationFormData.json';
  import { useVuelidate } from '@vuelidate/core';
  import { required, helpers, minLength, maxLength } from '@vuelidate/validators';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LocationForm',
  emits: ["onNextClick", "onPrevClick"],
  setup(__props, { emit }: { emit: ({
    (e: 'onNextClick', formData: LocationData): void;
    (e: 'onPrevClick',): void;
  }), expose: any, slots: any, attrs: any }) {

  

  const technologies = ref(locationFormData.eventTechnology);

  const locationData = ref<LocationData>(new LocationData());

  const formItems: FormItem[] = [
    new FormItem('locationName', 'Locationname*', undefined, 'text', 'Name der Location', undefined),
    new FormItem('zipCode', 'Postleitzahl*', undefined, 'zip', 'PLZ der Location', undefined),
    new FormItem('city', 'Ort*', undefined, 'text', 'Ort der Location', undefined),
    new FormItem('eventTechnology', 'Veranstaltungstechnik', technologies.value, 'selectbutton', undefined, 'name')
  ];

  const validationRules = {
    locationName: { required: helpers.withMessage('Name der Location', required) },
    zipCode: { required: helpers.withMessage('Postleitzahl der Location', required), 
      minLength: helpers.withMessage('5 Ziffern', minLength(5)),
      maxLength: helpers.withMessage('5 Ziffern', maxLength(5))
    },
    city: { required: helpers.withMessage('Ort der Location', required) },
    eventTechnology: { required: helpers.withMessage('Technologie in Location?', required) }
  }

  const v$ = useVuelidate(validationRules, locationData);

  const validated = ref(false);
  const nextPage = async() => {
    validated.value = true;
    const isFormValid = await v$.value.$validate();
    if (isFormValid) {
      emit('onNextClick', locationData.value);
    }
  }
 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(formItems, (item, index) => {
        return _createElementVNode("div", { key: index }, [
          _createVNode(InputField, {
            class: _normalizeClass((_unref(v$)[item.selectedKey].$invalid || _unref(v$)[item.selectedKey].$pending) && validated.value ? 'invalid' : ''),
            type: item.type,
            label: item.label,
            selected: _unref(v$)[item.selectedKey].$model,
            "onUpdate:selected": ($event: any) => ((_unref(v$)[item.selectedKey].$model) = $event),
            options: item.options,
            optionLabel: item.optionLabel,
            placeholder: item.placeholder,
            id: item.selectedKey
          }, {
            errorMessage: _withCtx(() => [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(v$)[item.selectedKey]?.$silentErrors?.length > 0 ? _unref(v$)[item.selectedKey].$silentErrors[0].$message : 'no'), 1)
            ]),
            _: 2
          }, 1032, ["class", "type", "label", "selected", "onUpdate:selected", "options", "optionLabel", "placeholder", "id"])
        ])
      }), 64))
    ]),
    _createVNode(FormButtons, {
      next: true,
      previous: true,
      onClickRight: nextPage,
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (emit('onPrevClick'))),
      class: "buttons"
    })
  ]))
}
}

})